export const SESSION_USER = "napclass";
export const SESSION_EXAM = "napclass-exam";
export const SESSION_MODE = "napclass-mode";
